import React, { useState, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { useSelector, useDispatch } from "react-redux";
import ThemMoiTinChap from "containers/DanhSachHopDongChoDuyet/Sua/suaTinChap";
// import ThemMoiTraGop from "containers/TraGop/SubContainer/themMoiTraGop";
import { convertDate } from "utils/formatDate";
import { showFormTraGop } from "actions/ThemMoiTraGop";
import { pushNotification } from "utils/notifications";
import {
  getListHopDongChoDuyet,
  updateDataSearch,
} from "../../../../../../actions/DanhSachHopDongChoDuyet";
import { getLaiSuat } from "constants/choVayConst";
import { getTotalDays } from "utils/choVayUtils";
import ChiTietHopDong from "../../../../../../service/chiTietHopDongApi";
export const BtnSuaTinChap = ({ item, showFormTinChap,isDuDungPhiPhatDongLaiTatToan,
  SuDungPhiPhat_DongLai_Cham,
  isSuDungCongTacVienNhanVien,
  isSuDungTatToanSom }) => {
  const [isModalVisible, setModalVisible] = useState(false);

  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongChoDuyet);

  const themmoitinchap = useSelector((state) => state.themmoitinchap);

  const choVayEdit = {};
  const [chovayChiTiet, setChoVay] = useState(choVayEdit);

  const loadTinChap = () => {
    getListHopDongChoDuyet(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const setModalTinChapShow = (chovay) => {
    let choVayEdit = { ...chovay };
    if (chovay) {
      choVayEdit.NgayVay = convertDate(chovay.NgayVay);
      choVayEdit.NgayTra = convertDate(chovay.NgayTra);
      choVayEdit.LaiSuat = getLaiSuat(chovay, chovay.KieuLaiSuat);
      choVayEdit.TongNgayVay = getTotalDays(
        choVayEdit.NgayVay,
        choVayEdit.NgayTra
      );
      if (choVayEdit.kyLai && parseFloat(choVayEdit.kyLai) > 0)
        choVayEdit.CountTypePaid = choVayEdit.kyLai;
    }
    ChiTietHopDong.getChiTietHopDong1(item.ChoVayId).then((response) => {
      setChoVay(response.data);
    });
    themmoitinchap.postTinChapReturn = false;
    themmoitinchap.TaiSanTinChap.AnhTaiSan = "";
    let { isShowFormTinChap } = themmoitinchap;
    if (isShowFormTinChap) {
      dataSearch.pageIndex = 1;
      loadTinChap(dataSearch);
    }
    showFormTinChap(choVayEdit);
    dispatch(getListHopDongChoDuyet(dataSearch));
    setModalVisible(!isModalVisible);
  };

  // useEffect(() => {
  //   setModalTraGopShow();
  // }, [item.ChoVayId]);

  return (
    <>
      <a onClick={(e) => setModalTinChapShow(item)} href={() => false}>
        <PopoversBootrap
          contentText="Sửa"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
        <img src="/app-assets/images/icon-edit-v2.png" />
        </PopoversBootrap>
      </a>

      {isModalVisible && (
        <ThemMoiTinChap
          show={isModalVisible}
          onHide={(e) => setModalTinChapShow(null)}
          data={chovayChiTiet}
          isDuDungPhiPhatDongLaiTatToan={isDuDungPhiPhatDongLaiTatToan}
             SuDungPhiPhat_DongLai_Cham={SuDungPhiPhat_DongLai_Cham}
                isSuDungCongTacVienNhanVien={isSuDungCongTacVienNhanVien}
                isSuDungTatToanSom={isSuDungTatToanSom}
        ></ThemMoiTinChap>
      )}
    </>
  );
};
